import Progressbar from './partials/progressbar';
import UserStatus from './partials/userstatus';

const progressBar = new Progressbar({imageId: 'image', elementId: 'TimeProgressBar', intervalMaxCounter: 20});

const userStatus = new UserStatus({elementId: 'UsersStatusList'});